import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import { ExcelDownload } from "./gobal-excel";
import { Card, CardBody, Col } from "reactstrap";
import React, { useEffect, useState } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import EmptyData from "../../../globals/EmptyData";
import MyCsvLink from "./gobel-csv";
import { Pagination } from "antd";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import overlayFactory from "react-bootstrap-table2-overlay";
import paginationFactory from "react-bootstrap-table2-paginator";
import Loading from "../loader/loader";
import { getUserRoleName } from "../azureLogin/authUtility";

const NkTable = (
  {
    data = [],
    dataEXCEL = [],
    columns = [],
    columnsCsv = [],
    loading,
    pagination,
    onPagechange,
    filename,
    pageSizeOptions,
    showSizeChanged,
    buttonRef,
    onExcelClciked,
    dataexcal,
    filterdata,
    type,
    clientSide,
    option,
    columnsExcel,
    pathname,
    rowEvents,
    rowOnClick,
    rowHandler,
    excelLoading = false,
  },
  props
) => {
  function rowStyleFormat(row, rowIdx) {
    return {
      backgroundColor: rowIdx % 2 === 0 ? " rgb(245 245 245)" : "#ffff",
      cursor: rowOnClick && "pointer",
    };
  }

  const roleName = getUserRoleName()

  let isVerifier = roleName === "CustomerServiceAgent";
  let isUser = roleName === "CallCenterAgent";

  useEffect(() => {
    isVerifier = roleName === "CustomerServiceAgent";
    isUser = roleName === "CallCenterAgent";
    setRowHandlerActive(rowHandler);
  }, []);
  const [rowHandlerActive, setRowHandlerActive] = useState(false);

  return (
    <>
      {data.length > 0 ? (
        <>
          <ToolkitProvider
            keyField="id"
            bootstrap4={true}
            loading={loading}
            data={data}
            columns={columns}
          >
            {(props) => (
              <BootstrapTable
                option={option}
                rowHandler={rowHandlerActive}
                rowEvents={rowOnClick}
                pagination={clientSide && paginationFactory()}
                rowStyle={rowStyleFormat}
                defaultSortDirection="desc"
                loading={loading} //only loading is true, react-bootstrap-table will render overlay
                overlay={overlayFactory({
                  spinner: true,
                  background: "rgba(192,192,192,0.3)",
                })}
                noDataIndication={() => (
                  <div
                    style={{
                      textAlign: "center",
                      fontFamily: "Montserrat-Medium",
                      fontSize: "18px",
                      padding: "10px 0px",
                    }}
                  >
                    No Records Found
                  </div>
                )}
                {...props.baseProps}
              />
            )}
          </ToolkitProvider>
          {pagination && pagination.total && data.length > 0 ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Card style={{ width: "100%" }}>
                <CardBody
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "0.5rem 1.5rem",
                  }}
                >
                  <Col
                    lg={11}
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    {!clientSide && (
                      <Pagination
                        style={{
                          display: "flex",
                          alignItems: "center",
                          width: "100%",
                          justifyContent: "center",
                        }}
                        current={pagination.current}
                        total={pagination.total}
                        pageSize={pagination.pageSize}
                        showSizeChanger={true}
                        pageSizeOptions={[10, 20, 30, 40, 50]}
                        onShowSizeChange={(current, pageSize) => {
                          showSizeChanged(pageSize);
                        }}
                        onChange={(page, size) => {
                          onPagechange(page, size);
                        }}
                        showTotal={(total, [from, to]) => {
                          return (
                            <>
                              {total && (
                                <span
                                  style={{
                                    padding: "0px 0px 0px 0px",
                                    fontSize: "13px",
                                    display: "flex",
                                  }}
                                >
                                  Showing rows {from} to {to} of {total}
                                </span>
                              )}
                            </>
                          );
                        }}
                      />
                    )}
                  </Col>

                  {dataexcal && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      {!isVerifier && !isUser ? (
                        <>
                          <div
                            className="download-xl"
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            {excelLoading ? (
                              <div
                                style={{
                                  textAlign: "center",
                                }}
                              >
                                <Loading
                                  color="#FFFFFF"
                                  width="25px"
                                  height="25px"
                                />
                              </div>
                            ) : (
                              <img
                                alt="..."
                                style={{ width: "45px", height: "45px" }}
                                src={require("assets/img/icons/common/xlsx.png")}
                                onClick={onExcelClciked}
                              />
                            )}
                          </div>
                          <ExcelDownload
                            dataSet={dataEXCEL}
                            columnKeys={columnsExcel ? columnsExcel : columns}
                            filename={filename}
                            element={
                              <button
                                style={{ display: "none" }}
                                ref={buttonRef}
                              ></button>
                            }
                          />
                        </>
                      ) : null}
                      {columnsCsv.length > 0 && !isVerifier && !isUser ? (
                        <>
                          <MyCsvLink
                            type={type}
                            filterdata={filterdata}
                            headers={columnsCsv}
                            filename={filename}
                          />
                        </>
                      ) : null}
                    </div>
                  )}
                </CardBody>
              </Card>
            </div>
          ) : (
            ""
          )}
        </>
      ) : (
        <EmptyData />
      )}
    </>
  );
};
export default NkTable;